import styled from 'styled-components';
import { animated } from 'react-spring';
import { COLORS, SIZING } from '../../../styles/variables';
import { device } from '../../../styles/devices';

export const DropDownWrapper = styled.section<{
  isOptional?: boolean;
  shouldApplyMargin?: boolean;
}>`
  position: relative;
  margin-bottom: ${({ isOptional }) => !isOptional && '60px'};
  margin-top: ${({ shouldApplyMargin }) => shouldApplyMargin && '24px'};
  font-family: Audi Type;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0.003px;
  width: 340px;
`;

export const Title = styled.h2`
  font-family: Audi Type Extended;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0.002px;
  color: ${COLORS.black};
  @media ${device.tablet} {
    font-size: 18px;
    line-height: 28px;
  }
`;

export const DropDownInput = styled.button`
  width: 340px;
  background: transparent;
  border: none;
  /* padding: 4px 0 8px 0; */
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid ${COLORS.grey80};
  position: relative;
  height: 37px;
  padding-top: 4px;
  padding-bottom: 8px;
  margin-top: 48px;
  cursor: pointer;
`;

export const DropDownSelect = styled(animated.div)`
  position: absolute;
  box-shadow:
    0px 2px 6px 0px rgba(0, 0, 0, 0.2),
    0px 1px 2px 0px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  background-color: ${COLORS.grey15};
  left: 0;
  width: 340px;
  color: ${COLORS.grey80};
  z-index: 100;
  contain: layout paint;
`;

export const DropDown = styled(animated.div)`
  padding: 8px 6px;
`;

export const ListTitle = styled.p`
  padding-bottom: 16px;
`;

export const ListOfOptions = styled(animated.ul)`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-items: flex-start;
  gap: 20px;
`;

export const TopicOption = styled.li`
  cursor: pointer;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 4px;
`;

export const DropdownLabel = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  gap: 8px;
`;

export const SubLabel = styled.label`
  font-family: Audi Type;
  font-size: 12px;
  line-height: 20px;
  color: ${COLORS.grey60};
  letter-spacing: 0.002px;
`;

export const ListOfTags = styled.ul`
  width: 340px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;
  padding-top: 16px;
  gap: 8px;
`;

export const TopicTag = styled.li`
  /* height: 24px; */
  padding: 6px 8px 6px 12px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 8px;
  background-color: rgba(0, 0, 0, 0.05);
`;

export const TitlePlaceholder = styled(animated.p)`
  position: absolute;
  color: ${COLORS.black};
`;
export const SelectedPlaceholder = styled.p`
  color: ${COLORS.black};
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  gap: 8px;
`;

export const ArrowIcons = styled.div`
  position: absolute;
  right: 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  z-index: -1;
`;

export const Checkbox = styled.div<{ checked?: boolean; disabled?: boolean }>`
  width: 20px;
  height: 20px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  background: transparent;
  &:hover {
    border-color: ${({ checked, disabled }) => (checked || disabled ? '' : COLORS.black)};
  }
  &:focus {
    outline: ${SIZING.unit(0.5)} auto Highlight;
    outline: ${SIZING.unit(0.5)} auto -webkit-focus-ring-color;
  }
`;

export const HiddenInput = styled.input`
  display: none;
`;

export const CloseIconWrapper = styled.button`
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border: none;
  background: initial;
  padding: 0;
`;
